import React, { useEffect, useState } from 'react';
import { ActivityIndicator } from '../../components/common/activity-indicator/activity-indicator';
import { DisclaimerList } from '../../components/common/disclaimer-list/disclaimer-list';
import { Masthead } from '../../components/common/masthead/masthead';
import { DisclosuresLink } from '../../components/sections';
import { SmashVehicleSelectorFds } from '../../components/sections/smash-vehicle-selector-fds/smash-vehicle-selector-fds';
import { disableLanguageLinksforTH } from '../../components/utils/syndicate-util/syndicate-util';
import { useAnalytics } from '../../hooks/use-analytics';
import useSeoConfig from '../../hooks/use-seo-config';
import { useExperienceContent } from '../../hooks/use-server-content';
import { CxYmm } from '../../models/experiencefragments/cx-ymm';
import { VehicleYmm, VehicleYmmGroup } from '../../models/vehicle-ymm';
import { findByAlias } from '../../routes';
import { DisclaimerContent } from '../../services/disclaimers-service/disclaimers-service';
import { useProcessedCxContent } from './hooks/use-processed-cx-content';

import '../cx-home-page/cx-home-page.scss';
import { CategoryVideoQuietCard } from '../../components/sections/category/categories/category-video-quiet-card/category-video-quiet-card';
import { HomeContentProps } from '../home-page/hooks/use-home-content';
interface HomeCTAVehicleSelectorProps {
    vehicleDropdownData: VehicleYmmGroup[];
    processedHomeContent: HomeContentProps;
    findByAlias: (alias: string) => string;
}
const HomeCTAVehicleSelector: React.FC<HomeCTAVehicleSelectorProps> = ({
    vehicleDropdownData,
    processedHomeContent,
    findByAlias,
}) => {
    return vehicleDropdownData.length !== 0 && processedHomeContent ? (
        <SmashVehicleSelectorFds
            vehicleDropdownData={vehicleDropdownData}
            articlesSearch={true}
            redirectData={{
                path: findByAlias('CxHandler'),
                id: 'learning-hub',
            }}
            ymmDefaultView={true}
            labels={{
                vinHeader: processedHomeContent.vehicleSelectorVinSubtitle,
                vinPlaceholder: processedHomeContent.vehicleSelectorVinInput,
                yearDropdown:
                    processedHomeContent.vehicleSelectorYearDropdownLabel,
                modelDropdown:
                    processedHomeContent.vehicleSelectorModelDropdownLabel,
                submit: processedHomeContent.vehicleSelectorSubmitButtonLabel,
                header: processedHomeContent.vehicleSelectorModelSubtitle,
                vehicleSelectorTitle: processedHomeContent.vehicleSelectorTitle,
                vehicleSelectorDescription:
                    processedHomeContent.vehicleSelectorDescription,
                vehicleSelectorDescriptionWithDisclaimer:
                    processedHomeContent.vehicleSelectorDescriptionWithDisclaimer,
                vehicleSelectorDescAuthState:
                    processedHomeContent.vehicleSelectorDescAuthState,
                segmentedControlVinButtonLabel:
                    processedHomeContent.segmentedControlVinButtonLabel,
                segmentedControlYearAndModelButtonLabel:
                    processedHomeContent.segmentedControlYearAndModelButtonLabel,
                whereDoIFindVinCta: processedHomeContent.whereDoIFindVinCta,
            }}
        />
    ) : (
        <></>
    );
};
export const CxHomePage = () => {
    let disclaimers: DisclaimerContent[] = [];
    const {
        processedDisclaimers,
        processedHomeContent,
        videoQuietCardOneDetails,
        videoQuietCardTwoDetails,
    } = useProcessedCxContent(disclaimers);
    disclaimers = disclaimers.concat(processedDisclaimers);
    const [vehicleDropdownData, setVehicleDropdownData] = useState<
        VehicleYmmGroup[]
    >([]);
    const [experienceContent] = useExperienceContent<CxYmm>(
        'img-cx-ymm',
        'cx-ymm',
        'img_cx_ymm'
    );
    useSeoConfig('home', 'learning-hub');

    useAnalytics('owner-dyf-landing-page');

    let vehicles: VehicleYmm[] = [];
    let vehicle: VehicleYmm = {
        year: 0,
        make: '',
        model: '',
        marketName: '',
        seoKey: '',
        id: '',
    };
    let vehicleDropdown: VehicleYmmGroup[] = [];
    let vehicleData: VehicleYmmGroup = {
        year: 0,
        vehicles: [],
    };

    experienceContent?.modelYearInclude.forEach(modelYears => {
        vehicle = {
            ...vehicle,
            year: parseInt(modelYears.modelYear),
        };
        modelYears.supportedModels.forEach(models => {
            vehicle = {
                ...vehicle,
                make: 'Ford',
                model: models.displayModelName,
                marketName: models.displayModelName,
                seoKey: models.seoKey,
            };
            vehicles.push(vehicle);
        });
        vehicleData = {
            ...vehicleData,
            year: parseInt(modelYears.modelYear),
            vehicles: [...vehicles],
        };
        vehicleDropdown = [...vehicleDropdown, vehicleData];
        vehicles = [];
    });

    useEffect(() => {
        disableLanguageLinksforTH();
        window.scroll(0, 0);
        setVehicleDropdownData([...vehicleDropdown]);
    }, [experienceContent]);

    return (
        <>
            {processedHomeContent ? (
                <div className="shared-view no-breadcrumb smash-home">
                    <div id="Hero">
                        <Masthead
                            class="cx-home-page"
                            headline={processedHomeContent.bannerTitle}
                            description={processedHomeContent.bannerDescription}
                            mobileImg={
                                processedHomeContent.homeBackgroundImageMobile ||
                                ''
                            }
                            desktopImg={
                                processedHomeContent.homeBackgroundImageDesktop ||
                                ''
                            }
                        ></Masthead>
                        {!processedHomeContent.hideVehicleSelector && (
                            <div className="cx-home-container">
                                <HomeCTAVehicleSelector
                                    vehicleDropdownData={vehicleDropdownData}
                                    processedHomeContent={processedHomeContent}
                                    findByAlias={findByAlias}
                                />
                            </div>
                        )}
                        {videoQuietCardOneDetails && (
                            <CategoryVideoQuietCard
                                videoQuietCardDetails={videoQuietCardOneDetails}
                                class="cx-video-quiet-card-main"
                            />
                        )}
                        {videoQuietCardTwoDetails && (
                            <CategoryVideoQuietCard
                                videoQuietCardDetails={videoQuietCardTwoDetails}
                                class="cx-video-quiet-card-main"
                            />
                        )}
                    </div>
                    {disclaimers.length > 0 && (
                        <DisclaimerList disclaimers={disclaimers} />
                    )}
                    <DisclosuresLink
                        class="cx-disclosure-content"
                        disclosuresType="learning-hub"
                    />
                </div>
            ) : (
                <ActivityIndicator className="full-height" />
            )}
        </>
    );
};
export default CxHomePage;
